import BaseBarChartWidgetController from './base_bar_chart_widget_controller';
import { BLUE_400, GREEN_400, GRAY_700 } from '../../../shared/colors';

export default class extends BaseBarChartWidgetController {
  getChartConfig(data) {
    const { expected_rate, actual_rate } = data;

    return {
      labels: ['', ''],
      values: [expected_rate, actual_rate],
      colors: [BLUE_400, GREEN_400],
    };
  }

  getChartOptions(maxValue) {
    return {
      ...super.getChartOptions(maxValue),
      scales: {
        ...super.getChartOptions(maxValue).scales,
        y: {
          beginAtZero: true,
          max: 100, // Fixed max for percentage
          grid: {
            display: false,
          },
          ticks: {
            color: GRAY_700,
            font: {
              size: 12,
            },
            callback: (value) => `${value}%`,
          },
        },
      },
    };
  }

  formatTooltipLabel(context) {
    return `${context.raw}%`;
  }
}
